import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { SdkRanking } from '../models/sdkRanking';

@Component({
  template: `<violation-risk
    [risk]="risk"
    (interact)="openInsight($event)"
  ></violation-risk> `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SdkViolationRiskComponent
  extends DataWidgetComponent
  implements OnInit
{
  @Input() data: SdkRanking;
  risk: string;

  ngOnInit(): void {
    super.ngOnInit();
    this.risk = this.data[this.key];
  }
}
